export default {
    init: ( element ) => {

      const google = window.google || false;

      if ( google ) {
        $(element).each(( i ) => {
            const $map = $(element).eq(i);
            if ( $map.length && $map.data('latitude') && $map.data('longitude') ) {

                var map = new google.maps.Map($map.get()[0], {
                  zoom: 13,
                  center: { lat: $map.data('latitude'), lng: $map.data('longitude') },
                });

                if ( window.mapCustomStyle ) {
                  map.setOptions({styles: window.mapCustomStyle});
                }

                if ( $map.data('marker-url') ) {
                  var image = {
                    url: $map.data('marker-url'),
                    size: new google.maps.Size(parseInt($map.data('marker-width')), parseInt($map.data('marker-height'))),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(parseInt($map.data('marker-width')) / 2, parseInt($map.data('marker-height'))),
                  };
                  new google.maps.Marker({
                    map: map,
                    image: image,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    position: { lat: $map.data('latitude'), lng: $map.data('longitude') },
                  });
                }
                else {
                  new google.maps.Marker({
                    map: map,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    position: { lat: $map.data('latitude'), lng: $map.data('longitude') },
                  });
                }

            }
        });
      }
    },
};



// WEBPACK FOOTER //
// ./scripts/util/MapGMap.js